export const TABLE_CHART_PAGINATION_PROPS = {
  pageRangeDisplayed: 3,
  marginPagesDisplayed: 1,
};
